import { SparklesIcon } from '@heroicons/react/24/solid';
import type { ComponentProps, ReactNode } from 'react';
import { Button } from './Button';

type AiIconButtonProps = Omit<ComponentProps<'button'>, 'children'> & {
  children?: ReactNode;
  size?: 'regular' | 'sm' | 'mini';
};

/**
 * AIアクション用ボタン
 *
 * グラデーションボーダー（brand-500 → brand-300）+ SparklesIcon を持つボタン。
 * children を渡すとテキスト付き、省略するとアイコンのみになる。
 * Figma: https://www.figma.com/design/K9BryoBh0t69xPihm3VBho/DnR_DesignSystem?node-id=5463-7137
 */
const AiIconButton = ({
  className,
  children,
  size,
  'aria-label': ariaLabel,
  ...props
}: AiIconButtonProps) => {
  const isIconOnly = !children;

  return (
    <Button
      type="button"
      variant="ai-gradient"
      size={isIconOnly ? 'icon' : (size ?? 'sm')}
      className={className}
      aria-label={isIconOnly ? (ariaLabel ?? 'AIアシスタント') : ariaLabel}
      {...props}
    >
      <SparklesIcon />
      {children}
    </Button>
  );
};

AiIconButton.displayName = 'AiIconButton';

export { AiIconButton };
